module.exports = __webpack_public_path__ + "static/media/close-strong-small.98110b2a.svg";